import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__p33LG"};
export const b = b_.with('modal');